// src/components/MapEmbed.jsx
export default function MapEmbed() {
  return (
    <section className="bg-white py-12 px-6 md:px-12">
      <div className="max-w-4xl mx-auto rounded-2xl overflow-hidden shadow-lg">
        <iframe
          title="Aarogyam Homeopathic Clinic Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d58885.64902461032!2d75.8712362919906!3d22.7151148825056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3962e3094d80f1cb%3A0xff6525b3a0e3b25a!2sAarogyam%20Homoeopathic%20Clinic!5e0!3m2!1sen!2sin!4v1750776328420!5m2!1sen!2sin"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
  );
}

